import { Box } from '@factorialco/deprecated-design-system'

import { OverviewLeftColumn } from './OverviewLeftColumn'
import { OverviewRightColumn } from './OverviewRightColumn'

interface ValidFeature {
  emoji: string
  title: string
  description: string
}

interface OverviewTabProps {
  moduleCarouselVideo?: string | null
  moduleCarouselImages: Array<{ url?: string | null }>
  moduleSlug?: string | null
  validFeatures: ValidFeature[]
  navatticImageUrl: string | null
  upsellModalBenefits: string[]
  onLearnMore: () => void
  onProductDemo: () => void
}

export const OverviewTab = ({
  moduleCarouselVideo,
  moduleCarouselImages,
  moduleSlug,
  validFeatures,
  navatticImageUrl,
  upsellModalBenefits,
  onLearnMore,
  onProductDemo,
}: OverviewTabProps) => (
  <Box
    flexDirection="row"
    gap="s0"
    alignItems="stretch"
    style={{ width: '100%', minWidth: '0', flex: '1', minHeight: '0' }}
  >
    <OverviewLeftColumn
      moduleCarouselVideo={moduleCarouselVideo}
      moduleCarouselImages={moduleCarouselImages}
      moduleSlug={moduleSlug}
      validFeatures={validFeatures}
    />
    <OverviewRightColumn
      navatticImageUrl={navatticImageUrl}
      upsellModalBenefits={upsellModalBenefits}
      onLearnMore={onLearnMore}
      onProductDemo={onProductDemo}
    />
  </Box>
)
